import { redirect } from 'react-router-dom'

const ORDERED_DEFAULT_ONBOARDING_ROUTES = [
  'running-experience',
  'commit-training',
  'one-session-time',
  'run-preference',
  'off-to-start',
  'usually-run',
  'other-activities',
  'injuries',
  'intensity-preference',
  'specific-event',
]

const YES_ROUTES = ['select-marathon', 'reveal-plan']
const NO_ROUTES = [
  'why-choose-run-baby-run',
  'accountable',
  'onboarding-completion',
]

// Store the updated routes array to avoid recalculating
let updatedOnboardingRoutes = [...ORDERED_DEFAULT_ONBOARDING_ROUTES]

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const currentPage = request.url.split('/').pop()?.split('?')[0]

  // Update routes array only when we reach specific-event page
  if (currentPage === 'specific-event') {
    const answer = formData.get('answer') as string

    if (answer === 'yes') {
      updatedOnboardingRoutes = [
        ...ORDERED_DEFAULT_ONBOARDING_ROUTES,
        ...YES_ROUTES,
      ]
    } else if (answer === 'no') {
      updatedOnboardingRoutes = [
        ...ORDERED_DEFAULT_ONBOARDING_ROUTES,
        ...NO_ROUTES,
      ]
    }
  }

  const next = getNext(request.url, updatedOnboardingRoutes)

  if (!next) return redirect('/sign-up/company')

  const nextPathname = getNextPathName({ next, url: request.url })

  if (currentPage === 'success') {
    const hash = formData.get('success') as string
    return redirect(`${nextPathname}#${hash}`)
  } else {
    return redirect(nextPathname)
  }
}

function getNext(url: string, routes: string[]): string | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split('/').pop()

  if (!current) return

  const currentIndex = routes.indexOf(current)
  const next = routes[currentIndex + 1]

  return next
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split('/')
  const basePathname = paths.slice(0, -1).join('/')
  const nextPathname = basePathname + '/' + next
  return nextPathname
}
